import React from 'react';
import Sidebar from './sidebar';
import FooterStyle from './footer';
import { Link } from 'react-router-dom';
import { PropertyCard } from './propertycard';


export const PropertiesPage = () => {

  return (
    <div className='top-layout'>
      <div className='Navbar'>
        <Sidebar />
      </div>
    
      <div className='layout'>

      <div className='KS-logo'>
          <Link to="/" style={{ position:'absolute', cursor: 'pointer', zIndex: '100'}}>
            <img src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="Logo" style={{ width: '4.5rem', marginTop:'0.3rem'}} />
          </Link>
        </div>

        <div className='backgroundImage'>
          <img src={process.env.PUBLIC_URL + '/images/RESORTS/Bespoke_Lobby_3.JPG'} alt="headImage" style={{ width: '100%', position:'relative', bottom:'2rem' }} />  
          <h1>PROPERTIES</h1>
        </div>

        <div className='contentproperties'>
          
          <div className='luxuryresorts'>
            <div className='luxuryresorts-content'>
              <h2>Luxury Resorts</h2>
            </div>
            {/* <InfoTitle
              className="info-value"
              title="Borneo Eagle Resort"
              value={process.env.PUBLIC_URL + '/images/RESORTS/Borneo_Eagle_Resort.webp'}
            /> */}
            <div className='luxuryresorts-content-card'>
              <PropertyCard
                imageUrl={process.env.PUBLIC_URL + '/images/RESORTS/Borneo_Eagle_Resort.webp'}
                title={'Borneo Eagle Resort'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/RESORTS/BR-1.webp'}
                title={'Bungaraya Island Resort'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/RESORTS/Gayana-Marine-Resort.jpg'}
                title={'Gayana Marine Resort'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
            </div>
              

          </div>
          <hr class="dotted" />
          
          <div className='premiumhotels'>
              <div className='premiumhotels-content'>
                <h2>Premium Hotels</h2>
              </div>
              <div className='premiumhotels-content-card'>
                <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/RESORTS/lmkkweb.jpg'}
                title={'Le Meridien Hotel Kota Kinabalu'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/RESORTS/bespoke.jpg'}
                title={'Bespoke Hotel Puchong'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              </div>
              

          </div>
          <hr class="dotted" />
          
          <div className='government'>
            <div className='government-content'>
              <h2>Government Buildings</h2>
            </div>
            <div className='government-content-card'>
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/GOVT BUILDING/BPKB.jpg'}
                title={'Bangunan Persekutuan Kota Belud'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/GOVT BUILDING/KPKPR.jpg'}
                title={'Kompleks Pentadbiran Kerajaan Persekutuan Ranau'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/GOVT BUILDING/KPKPS.jpg'}
                title={'Kompleks Pentadbiran Kerajaan Persekutuan Sabah'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/GOVT BUILDING/RPB.jpg'}
                title={'Rumah Persekutuan Beaufort'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/GOVT BUILDING/RPK.jpg'}
                title={'Rumah Persekutuan Keningau'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/GOVT BUILDING/RPKK.jpg'}
                title={'Rumah Persekutuan Kota Kinabalu'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/GOVT BUILDING/WDBKK.jpg'}
                title={'Wisma Dang Bandang Kota Kinabalu'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/GOVT BUILDING/WPS.jpg'}
                title={'Wisma Persekutuan Sandakan'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/GOVT BUILDING/WPT.jpg'}
                title={'Wisma Persekutuan Tawau'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
            </div>
              

          </div>
          <hr class="dotted" />
          
          <div className='commercial'>
            <div className='commercial-content'>
              <h2>Commercial & Residential</h2>
            </div>
          
            <div className='commercial-content-card'>
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/RESORTS/pkmfront.jpg'}
                title={'Sedco Industrial Estate'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/RESORTS/swcfront.jpg'}
                title={'Swiss Wellness Center , Kota Kinabalu & Kuala Lumpur'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
              <PropertyCard 
                imageUrl={process.env.PUBLIC_URL + '/images/RESORTS/pinnacleproperty.jpg'}
                title={'The Pinnacle'}
                style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
              />
            </div>

          </div>
        </div>


        <div className='footer'>
          <FooterStyle />
        </div>

      </div>


    </div>
  );
}

export default PropertiesPage;